<!-- Cột viên chỉ tồn tại khi có lượt đang thu nhỏ. Không dùng [hidden]: cột nằm `position: fixed` nên một
     thẻ rỗng vẫn chặn chuột ở góc màn hình dù không thấy gì. -->
@if (docked().length) {
    <!-- `column-reverse`: viên MỚI NHẤT nằm sát đáy, chỗ mắt nhìn tới trước và tay bấm dễ nhất. Các lượt
         cũ đẩy dần lên trên, nên vị trí của một viên không nhảy khi có lượt mới. -->
    <div class="bidock-stack">
        @for (item of docked(); track item.Id) {
            <button
                type="button"
                class="bidock"
                data-access-audit="local-only"
                [class.bidock--done]="item.Progress.Phase === 'done'"
                [class.bidock--attention]="item.Progress.Phase === 'attention'"
                (click)="session.restore(item.Id)"
                [attr.aria-label]="'shipment-import.bulk.dock.restore' | transloco"
            >
                <span class="bidock__head">
                    <!-- Xong rồi thì THÔI QUAY. Vòng quay là lời hứa "còn đang chạy"; để nó quay tiếp lúc
                         mọi việc đã dừng là nói sai, và người dùng ngồi đợi một thứ đã xong từ lâu. -->
                    @if (isTerminal(item)) {
                        <span class="bidock__mark" aria-hidden="true"></span>
                    } @else {
                        <span class="bidock__spinner" aria-hidden="true"></span>
                    }
                    <span class="bidock__text">
                        <span class="bidock__title">{{ phaseLabel(item) | transloco }}</span>
                        <span class="bidock__sub" [title]="item.File.name">{{ item.File.name }}</span>
                    </span>
                </span>

                <!-- Chỉ vẽ thanh khi CÓ MẪU SỐ. Lúc đang đọc tệp chưa biết tệp có bao nhiêu lô, mà một
                     thanh không có mẫu số thì chỉ còn cách chạy giả — nói dối người đang chờ. -->
                @if (item.Progress.Total > 0) {
                    <span
                        class="bidock__bar"
                        role="progressbar"
                        [attr.aria-valuenow]="item.Progress.Done"
                        [attr.aria-valuemin]="0"
                        [attr.aria-valuemax]="item.Progress.Total"
                    >
                        <span class="bidock__bar-seg bidock__bar-seg--done" [style.width.%]="percent(item, item.Progress.Done)"></span>
                        <span class="bidock__bar-seg bidock__bar-seg--pending" [style.width.%]="percent(item, item.Progress.Pending)"></span>
                        <span class="bidock__bar-seg bidock__bar-seg--failed" [style.width.%]="percent(item, item.Progress.Failed)"></span>
                    </span>

                    <span class="bidock__counts">
                        <span class="bidock__count bidock__count--done">
                            {{ 'shipment-import.bulk.dock.done' | transloco: { done: item.Progress.Done, total: item.Progress.Total } }}
                        </span>
                        @if (item.Progress.Running > 0) {
                            <span class="bidock__count bidock__count--running">
                                {{ 'shipment-import.bulk.dock.running' | transloco: { count: item.Progress.Running } }}
                            </span>
                        }
                        @if (item.Progress.Pending > 0) {
                            <span class="bidock__count bidock__count--pending">
                                {{ 'shipment-import.bulk.dock.pending' | transloco: { count: item.Progress.Pending } }}
                            </span>
                        }
                        @if (item.Progress.Failed > 0) {
                            <span class="bidock__count bidock__count--failed">
                                {{ 'shipment-import.bulk.dock.failed' | transloco: { count: item.Progress.Failed } }}
                            </span>
                        }
                    </span>
                }
            </button>
        }
    </div>
}
